import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Create the context
const AuthContext = createContext();

// Export the hook for consuming the context
export const useAuth = () => useContext(AuthContext);

// Provide the context
export function AuthProvider({ children }) {
  const [user, setUser ] = useState(null);
  const navigate = useNavigate();

  // Load user from localStorage on mount
  useEffect(() => {
    const savedUser  = localStorage.getItem("user");
    if (savedUser ) {
      try {
        setUser (JSON.parse(savedUser ));
      } catch (error) {
        console.error("Failed to parse user data from localStorage", error);
      }
    }
  }, []);

  // Login function
  const login = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser (userData);
    navigate("/auth/dashboard");
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("user");
    setUser (null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
